import { render, staticRenderFns } from "./Posicao.vue?vue&type=template&id=44b28cea&"
import script from "./Posicao.vue?vue&type=script&lang=js&"
export * from "./Posicao.vue?vue&type=script&lang=js&"
import style0 from "./Posicao.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports